import { Component } from '@angular/core';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';

import { UNLOCKACCOUNTLABELS } from '../_constants/constants';
import { CustomerService } from '../_services/customer.service';
import { Address, getUpdatePersonFromDetails, PersonDetails, PersonDetailsUpdate } from '../_models/data.structures';

export interface UnlockAccountDialogModel {
    title: string;
    previousData: PersonDetails;
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
}

@Component({
    templateUrl: 'unlock.account.dialog.component.html'
})

export class UnlockAccountDialogComponent extends DialogComponent<UnlockAccountDialogModel, string> implements UnlockAccountDialogModel {
    previousData: PersonDetails;
    title: string;
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
    person: PersonDetailsUpdate;
    
    unlockaccountlabels = UNLOCKACCOUNTLABELS;

    constructor(private ds: DialogService) {
          super(ds);
    }

    unlockAccountRequest() {
        try{
            if(this.opcoValue === 'vo'){
                this.person = getUpdatePersonFromDetails(this.previousData);
                this.person.locked_until = '0';
                this.customerService.saveUpdatedUser(this.person, this.subValue, this.opcoValue, this.ds);
            }
        }catch(e) {
            console.log(e);
        }
        
       this.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/unlockaccount/unlock.account.dialog.component.ts